import { IReferenceData } from '../interfaces/form/reference-data.model';

export interface ILocationData {
    locationCode?: string;
    locationName?: string;
    locationKey?: string;
}

export class Location implements IReferenceData {
    id: string;
    description: string;
    sortOrder?: number;
    value?: string;
    locationCode: string;
    locationKey: string;
    dbn: string;
    locationName: string;

    constructor(data: Partial<ILocationData>) {
        this.locationCode = data?.locationCode;
        this.id = data?.locationCode;
        this.dbn = data?.locationCode;
        this.value = data?.locationCode;
        this.description = data?.locationName;
        this.locationName = data?.locationName;
        this.locationKey = data?.locationKey;
    }
}